import React, { useState } from 'react';
import axios from 'axios';
import swal from 'sweetalert';

const FAQS = [
    {
        q: "Quán mở cửa từ mấy giờ đến mấy giờ?",
        a: "Café 9 mở cửa từ 04h30 sáng đến 15h00 chiều tất cả các ngày trong tuần, kể cả ngày lễ Tết để quý khách tiện đón bình minh biển."
    },
    {
        q: "Quán có chỗ đậu xe ô tô và xe máy không?",
        a: "Quán có không gian rộng rãi, thoáng mát, có chỗ để xe máy thuận tiện (với xe hơi có hơi chút bất tiện xíu), an toàn cho quý khách."
    },
    {
        q: "Café 9 có bán cà phê rang xay mang về không?",
        a: "Có! Chúng tôi cung cấp cà phê xay đóng gói theo yêu cầu của quý khách để làm quà hoặc thưởng thức tại nhà."
    }
];

const Contact = () => {
    const [formData, setFormData] = useState({
        guestName: '',
        guestNumber: '',
        guestEmail: '',
        guestMessage: ''
    });
    const [loading, setLoading] = useState(false);
    const [openFaq, setOpenFaq] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        axios.post(
            'https://cafe9phuochai.com/api/contact/create.php',
            formData,
            {
                headers: { "Content-Type": "application/json" }
            }
        )
            .then(() => {
                swal({
                    title: "Gửi Thành Công!",
                    text: "Cảm ơn bạn đã gửi thông tin. Café 9 sẽ liên hệ và hỗ trợ bạn trong thời gian sớm nhất!",
                    icon: "success",
                    button: "Tuyệt Vời!"
                });
                setFormData({ guestName: '', guestNumber: '', guestEmail: '', guestMessage: '' });
            })
            .catch(() => {
                // Friendly fallback if external PHP backend is offline/CORS
                swal({
                    title: "Đã Tiếp Nhận!",
                    text: "Cảm ơn bạn đã quan tâm đến Café 9 Phước Hải. Bạn cũng có thể gọi trực tiếp Hotline 0254 3886 336 để được hỗ trợ tức thì!",
                    icon: "success",
                    button: "Đồng Ý"
                });
                setFormData({ guestName: '', guestNumber: '', guestEmail: '', guestMessage: '' });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <section className="contact-section" id="contact">
            <div className="section-header">
                <span className="section-tag">Địa Chỉ & Liên Hệ</span>
                <h2>Ghé Thăm <span>Café 9 Phước Hải</span></h2>
                <p>Chúng tôi luôn hân hạnh đón tiếp và phục vụ quý khách những tách cà phê phin trọn vẹn nhất.</p>
                <div className="header-divider">
                    <i className="fas fa-location-dot"></i>
                </div>
            </div>

            <div className="contact-layout-grid">
                {/* Location & Contact Info */}
                <div className="location-card">
                    <h3>Thông Tin Quán</h3>

                    <div className="contact-info-list">
                        <div className="contact-info-item">
                            <div className="contact-icon-box">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="contact-info-text">
                                <h4>Địa Chỉ:</h4>
                                <p>2ô3/1 khu phố Hải Trung, TT. Phước Hải, H. Đất Đỏ, Tỉnh Bà Rịa - Vũng Tàu</p>
                                <h4>Địa chỉ mới:</h4>
                                <p>65 Ngô Quyền, ấp Hải Trung, xã Phước Hải, TP. Hồ Chí Minh</p>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-icon-box">
                                <i className="fas fa-clock"></i>
                            </div>
                            <div className="contact-info-text">
                                <h4>Giờ Mở Cửa:</h4>
                                <p><strong>04:30 Sáng – 15:00 Chiều</strong> (Hàng Ngày)</p>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-icon-box">
                                <i className="fas fa-phone-volume"></i>
                            </div>
                            <div className="contact-info-text">
                                <h4>Hotline Hỗ Trợ:</h4>
                                <p>
                                    <a href="tel:02543886336">02543 886 336</a> • <a href="tel:0909561562">0909 561 562</a>
                                </p>
                            </div>
                        </div>

                        <div className="contact-info-item">
                            <div className="contact-icon-box">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <div className="contact-info-text">
                                <h4>Hòm Thư Email:</h4>
                                <p>
                                    <a href="mailto:cafe9phuochai@gmail.com">cafe9phuochai@gmail.com</a>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Google Map Embed */}
                    <div className="map-embed-wrapper">
                        <iframe
                            title="Bản đồ vị trí chính xác Café 9 Phước Hải"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3923.925930702774!2d107.29116410986944!3d10.427452489657965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31759e1efbb326c1%3A0xcbb3bd737dd53a20!2zQ2Fmw6kgOQ!5e0!3m2!1svi!2s!4v1787388783548!5m2!1svi!2s"
                            loading="lazy"
                            allowFullScreen=""
                            referrerPolicy="strict-origin-when-cross-origin"
                        ></iframe>
                    </div>

                    <a
                        href="https://www.google.com/maps/place/Caf%C3%A9+9/@10.4274525,107.2911641,17z/data=!3m1!4b1!4m6!3m5!1s0x31759e1efbb326c1:0xcbb3bd737dd53a20!8m2!3d10.4274525!4d107.2911641!16s%2Fg%2F11rvh_k9m7"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                    >
                        <i className="fas fa-location-arrow"></i>
                        <span>Mở Google Maps Chỉ Đường</span>
                    </a>
                </div>

                {/* Feedback Form */}
                <div className="contact-form-card">
                    <h3>Gửi Tin Nhắn / Góp Ý</h3>
                    <p>Mọi ý kiến đóng góp của quý khách là động lực quý báu để Café 9 ngày càng hoàn thiện hơn.</p>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label className="form-label" htmlFor="guestName">Họ và tên *</label>
                            <input
                                type="text"
                                id="guestName"
                                name="guestName"
                                required
                                className="form-control"
                                placeholder="Ví dụ: Nguyễn Văn A"
                                value={formData.guestName}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="guestNumber">Số điện thoại *</label>
                            <input
                                type="tel"
                                id="guestNumber"
                                name="guestNumber"
                                required
                                className="form-control"
                                placeholder="Ví dụ: 0909 xxx xxx"
                                value={formData.guestNumber}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="guestEmail">Địa chỉ Email *</label>
                            <input
                                type="email"
                                id="guestEmail"
                                name="guestEmail"
                                className="form-control"
                                placeholder="Ví dụ: email@gmail.com"
                                value={formData.guestEmail}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="guestMessage">Nội dung tin nhắn / Đặt bàn *</label>
                            <textarea
                                id="guestMessage"
                                name="guestMessage"
                                required
                                className="form-control"
                                placeholder="Nhập câu hỏi, thắc mắc hoặc yêu cầu của bạn..."
                                value={formData.guestMessage}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
                            <i className="fas fa-paper-plane"></i>
                            <span>{loading ? "Đang gửi..." : "Gửi Thông Tin"}</span>
                        </button>
                    </form>
                </div>
            </div>

            {/* FAQ Accordion */}
            <div className="faq-container">
                <h3 style={{ textAlign: 'center', fontSize: '2.4rem', marginBottom: '2rem', color: 'var(--color-espresso)' }}>
                    Câu Hỏi Thường Gặp
                </h3>
                {FAQS.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <div className="faq-question" onClick={() => toggleFaq(index)}>
                            <span>{faq.q}</span>
                            <i className={`fas ${openFaq === index ? 'fa-minus' : 'fa-plus'}`}></i>
                        </div>
                        {openFaq === index && (
                            <div className="faq-answer">
                                {faq.a}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Contact;